import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuthUser } from "@/hooks/useAuth";

const STORAGE_KEY = "dhc:last-activity-log";
const ONE_HOUR = 60 * 60 * 1000;

/**
 * Registra a atividade diária do usuário logado.
 * Chama log_user_activity() na montagem e no máximo 1x/hora.
 */
export function useActivityTracker() {
  const { data: user } = useAuthUser();

  useEffect(() => {
    if (!user?.id) return;

    const shouldLog = () => {
      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return true;
        const parsed = JSON.parse(raw) as { userId: string; ts: number };
        if (parsed.userId !== user.id) return true;
        return Date.now() - parsed.ts > ONE_HOUR;
      } catch {
        return true;
      }
    };

    if (!shouldLog()) return;

    supabase.rpc("log_user_activity").then(({ error }) => {
      if (!error) {
        try {
          localStorage.setItem(
            STORAGE_KEY,
            JSON.stringify({ userId: user.id, ts: Date.now() })
          );
        } catch {
          /* noop */
        }
      }
    });
  }, [user?.id]);
}
